/**
 * TemplateCampoTemplate — alvos do "Teste de Página" (URLs a abrir/medir), filhos de Template.
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { RelatedEntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import TemplateCampo from '../../../models/TemplateCampo';
import TemplateModel from '../../../models/Template';

const model = {
  monitoramentotemplate: {
    exibir: 'main.template.campo.monitoramentotemplate',
    visivel: true,
    tipo: 'relacao',
    camporelacao: 'descricao',
    entidade: 'monitoramentotemplate.entidade',
    template: 'monitoramentotemplate.template',
    validacao: { obrigatorio: true },
  },
  nome: { exibir: 'main.template.campo.nome', visivel: true, validacao: { obrigatorio: true } },
  descricao: { exibir: 'main.template.campo.descricao' },
  url: { exibir: 'main.template.campo.url', visivel: true, validacao: { obrigatorio: true } },
  template: { exibir: 'main.template.campo.template', validacao: { obrigatorio: true } },
  visivel: { exibir: 'main.template.campo.visivel', tipo: 'boolean' },
  classificar: { exibir: 'main.template.campo.classificar', tipo: 'boolean' },
};

const renderers = {
  'monitoramentotemplate.entidade': TemplateModel,
  'monitoramentotemplate.template': (rowData) => rowData.monitoramentotemplate?.descricao || '',
};

class TemplateCampoFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.template.campo.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 mt-3"><ModelDropDown model={model.monitoramentotemplate} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.nome} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.descricao} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelTextInput model={model.url} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelTextInput model={model.template} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelBoolean model={model.visivel} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelBoolean model={model.classificar} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class TemplateCampoTemplate extends Component {
  render() {
    return (
      <RelatedEntityGrid
        entidade={TemplateCampo}
        model={model}
        identidade="main.template.campo"
        icone="pi-link"
        permissoes={this.props.permissoes}
        storageKey="dt-templatecampos"
        processos={[]}
        relacionados={[]}
        renderers={renderers}
        configuracao={this.props.configuracao}
        formulario={(m, ctx) => <TemplateCampoFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default TemplateCampoTemplate;
